import { atom } from "jotai";
import { atomFamily } from "jotai-family";
import { TimeseriesItem, TimeseriesItemDataRecord } from "types";
import { HoveredNearestPoint } from "./Timeseries.types";

type TimeseriesItemState =
  | TimeseriesItem<string, TimeseriesItemDataRecord<string>>
  | undefined;

export const legendHoverAtomFamily = atomFamily((_key: string) =>
  atom<TimeseriesItemState>(undefined)
);

export const legendDataSourceHoverFamily = atomFamily((_key: string) =>
  atom<string | undefined>(undefined)
);

export const hoveredLineAtomFamily = atomFamily((_key: string) =>
  atom<TimeseriesItemState>(undefined)
);

export const hoveredNearestPointAtomFamily = atomFamily((_key: string) =>
  atom<HoveredNearestPoint | undefined>(undefined)
);

export const disabledLegendItemsFamily = atomFamily((_key: string) =>
  atom<TimeseriesItem<string, TimeseriesItemDataRecord<string>>[]>([])
);

export const disabledDataKeysFamily = atomFamily((_key: string) =>
  atom<string[]>([])
);

export const hoveredXAxisLabelFamily = atomFamily((_key: string) =>
  atom<string | undefined>(undefined)
);
